import { render, staticRenderFns } from "./CMAccountMemberDetail.vue?vue&type=template&id=d5724dae&"
import script from "./CMAccountMemberDetail.vue?vue&type=script&lang=js&"
export * from "./CMAccountMemberDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5724dae')) {
      api.createRecord('d5724dae', component.options)
    } else {
      api.reload('d5724dae', component.options)
    }
    module.hot.accept("./CMAccountMemberDetail.vue?vue&type=template&id=d5724dae&", function () {
      api.rerender('d5724dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMAccountMemberDetail.vue"
export default component.exports